// IAA standard-volume buyer fee (effective Nov 4, 2024).
// Keep in sync with bidcaribbean-server/src/utils/landed/landedCost.js.
const IAAI_BUYER_FEES = [
  [49.99, 25], [99.99, 45], [199.99, 80], [299.99, 130], [349.99, 137.5], [399.99, 145],
  [449.99, 175], [499.99, 185], [549.99, 205], [599.99, 210], [699.99, 240], [799.99, 270],
  [899.99, 295], [999.99, 320], [1199.99, 375], [1299.99, 395], [1399.99, 410], [1499.99, 430],
  [1599.99, 445], [1699.99, 465], [1799.99, 485], [1999.99, 510], [2399.99, 535], [2499.99, 570],
  [2999.99, 610], [3499.99, 655], [3999.99, 705], [4499.99, 725], [4999.99, 750], [5499.99, 775],
  [5999.99, 800], [6499.99, 825], [6999.99, 845], [7499.99, 880], [7999.99, 900], [8499.99, 925],
  [9999.99, 945], [14999.99, 1000],
];

export const IAAIBuyerFeeCalculator = (amount) => {
  const row = IAAI_BUYER_FEES.find(([max]) => amount <= max);
  return row ? row[1] : amount * 0.075;
};
